import { useState } from 'react'

import { SelectOption } from 'components/Select'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_PREBID_MODULES_FOR_SELECT } from './api/query'
import { Data, PrebidModuleSliceDTO, Variables } from './api/types'
import {
  PrebidModuleSlice,
  UseGetPrebidModulesForSelect,
  UseGetPrebidModulesForSelectProps,
} from './types'

export const useGetPrebidModulesForSelect = ({
  moduleType,
}: UseGetPrebidModulesForSelectProps): UseGetPrebidModulesForSelect => {
  const [options, setOptions] = useState<SelectOption<PrebidModuleSlice>[]>([])

  useQuery<Variables, Data>({
    onCompleted: async (data: Data): Promise<void> => {
      const {
        prebidModules: { nodes: modules },
      } = data

      if (modules && modules.length > 0) {
        setOptions(
          modules.map(
            (module: PrebidModuleSliceDTO): SelectOption<PrebidModuleSlice> => fromDTO(module),
          ),
        )
      }
    },

    query: GET_PREBID_MODULES_FOR_SELECT,
    variables: { moduleType },
  })

  return { options }
}
